import React from 'react';
import { Row, Col } from 'antd';
import AboutTile from '../../AbouTile';
import { stripTags, domHtml } from '../../../utils/stripTags';

import SEO from '../../Seo';

const pageText = {
  paraOne: `Hey there! I'm Sidharth. I'm currently a senior at Singapore University of Technology
  and Design, majoring in Information Systems with a specialization in Artificial Intelligence.`,
  paraTwo: `I aspire to become a Software Engineer and am currently pursuing modules which gear me towards
  learning more about parallel and distributed programming. I've also taken a few AI related modules to better
  help my foundation in those fields of CS as well. Feel free to check out my projects and work experience to get a better understanding
  of the work I do!:)`,
};

const AboutMe = () => {
  const description = `${pageText.paraOne} ${stripTags(pageText.paraTwo)}`;
  return (
    <>
      <div>
        <SEO
          title="About"
          description={description}
          path=""
          keywords={['Sidharth', 'Praveen', 'FullStack developer', 'Javascript', 'ReactJS', 'NodeJS']}
        />
        <h1 className="titleSeparate">About Me</h1>
        <p>
          {pageText.paraOne}
        </p>
        <p dangerouslySetInnerHTML={domHtml(pageText.paraTwo)} />
      </div>
      <Row gutter={[20, 20]}>
        <Col xs={24} sm={24} md={12} lg={8}>
          <AboutTile
            img="location.png"
            height={60}
            alt="location image"
            textH4="Lives in"
            textH3="Singapore"
          />
        </Col>
        <Col xs={24} sm={24} md={12} lg={8}>
          <AboutTile
            img="graduation.png"
            alt="graduation image"
            textH4="Singapore University of Technology and Design"
            textH3="B.Eng, Computer Science"
            height={60}
            width={60}
          />
        </Col>
        
        <Col xs={24} sm={24} md={12} lg={8}>
          <AboutTile
            img="work.png"
            alt="work image"
            textH4="Graduating in August 2021"
            textH3="Software Engineer Roles"
          />
        </Col>
      </Row>
    </>
  );
};
export default AboutMe;
